export default class ErrorsController {
    constructor($scope) {
        'ngInject';

        this.$scope = $scope;
        this.$scope.angular = angular;

        this.alerts = {};
    }

    $onInit() {
        $(document).bind('click', event => {
            this.dismiss();
            this.$scope.$apply();
        });
    }

    dismiss(type) {
        if (type) {
            delete (this.alerts[type]);
            return;
        }
        this.alerts = {};
    }

}
